<div class="sections" coreActivitySection="Sections">
  <button class="section rewards" (click)="setState('rewards')" coreUserActivityClickTracking="RewardsOpen">
    <img src="/images/service-center-sections/rewards.webp" width="153" height="153" alt="Rewards"/>
    <div class="label">
      {{ 'serviceCenter.sections.rewards.rewards' | translate }}
    </div>
  </button>
  <button class="section promo" (click)="setState('promo')" coreUserActivityClickTracking="PromoOpen">
    <img src="/images/service-center-sections/promos.webp" width="153" height="153" alt="Promos"/>
    <div class="label">
      {{ 'serviceCenter.sections.promo.promo' | translate }}
    </div>
  </button>
  <button class="section gift" (click)="setState('gift')" coreUserActivityClickTracking="GiftOpen">
    <img src="/images/service-center-sections/gift-cards.webp" width="153" height="153" alt="Gift Cards"/>
    <div class="label">
      {{ 'serviceCenter.sections.gift.gift' | translate }}
    </div>
  </button>
  <button class="section more" (click)="setState('more')" coreUserActivityClickTracking="MoreOpen">
    <img src="/images/service-center-sections/more.webp" width="153" height="153" alt="More"/>
    <div class="label">
      {{ 'serviceCenter.sections.more.more' | translate }}
    </div>
  </button>
</div>

@switch (state()) {
  @case ('more') {
    <app-screen-more
      class="full-page"
      @InOutAnimation
      (back)="setState('main')"
    />
  }
  @case ('rewards') {
    <app-screen-rewards
      class="full-page"
      @InOutAnimation
      (back)="setState('main')"
    />
  }
  @case ('gift') {
    <app-screen-gift-cards
      class="full-page"
      @InOutAnimation
      (back)="setState('main')"
    />
  }
  @case ('promo') {
    <app-screen-special
      class="full-page"
      @InOutAnimation
      (back)="setState('main')"
    />
  }
}
